'use strict';

var pxToNumber = {};

exports.__exports = pxToNumber;
//# sourceMappingURL=pxToNumber.cjs.map
